module.exports = __webpack_public_path__ + "static/media/thelittle.yellowhouse-IG-2.453a0815.PNG";